import { type FC } from 'react';

import { Container } from '../common/Container';
import { Text } from '../common/Text';

import styles from './IntegrationsMethodSpecsBlock.module.scss';
import {
  MethodSpecsBookIcon,
  MethodSpecsGatewayCardIcon,
  MethodSpecsH2HIcon,
  MethodSpecsP2PIcon,
  MethodSpecsWalletIcon,
} from './MethodSpecsIcons';

type MethodSpecItem = {
  id: string;
  title: string;
  description: string;
  Icon: FC;
};

const METHOD_SPECS: MethodSpecItem[] = [
  {
    id: 'gateway',
    title: 'Card (Gateway)',
    description: 'Standard integration via our secure payment widget. Minimal setup time, maximum security.',
    Icon: MethodSpecsGatewayCardIcon,
  },
  {
    id: 'h2h',
    title: 'Card H2H',
    description:
      'For businesses that require a fully customized checkout experience on their own side (PCI DSS compliance required).',
    Icon: MethodSpecsH2HIcon,
  },
  {
    id: 'p2p',
    title: 'P2P',
    description: 'Person-to-person transfers optimized for high-speed processing and stability in emerging markets.',
    Icon: MethodSpecsP2PIcon,
  },
  {
    id: 'apm',
    title: 'APM',
    description: 'Local wallets, mobile payments, and bank transfers — essential for capturing local market share.',
    Icon: MethodSpecsWalletIcon,
  },
];

export const IntegrationsMethodSpecsBlock: FC = () => {
  return (
    <Container className={styles.root}>
      <div className={styles.sectionHead}>
        <span className={styles.sectionIcon} aria-hidden>
          <MethodSpecsBookIcon />
        </span>

        <h2 className={styles.sectionTitle}>Method Specifications</h2>
      </div>

      <div className={styles.cards}>
        {METHOD_SPECS.map(({ id, title, description, Icon }) => (
          <article key={id} className={styles.card}>
            <div className={styles.cardIconWrap} aria-hidden>
              <Icon />
            </div>

            <Text type="h3" color="white" className={styles.cardTitle}>
              {title}
            </Text>

            <Text type="regular14" color="white50" whiteSpace="normal" className={styles.cardDescription}>
              {description}
            </Text>
          </article>
        ))}
      </div>
    </Container>
  );
};
